__webpack_require__.p = "/scheduler-shared-module-refactor/referrals-hub/";